import React from 'react'
import { css } from 'aphrodite'
import { Row } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import Authbar from './partials/authbar'
import Navbar from './partials/navbar'

import style from './style'

@inject('Auth')
@observer
export class Header extends React.Component {
  onLogoutClick() {
    this.props.Auth.logout().then(() => window.location.reload())
  }

  render() {
    return [
      <Row key={0} className={css(style.authbar.wrapper)}>
        <Authbar
          onLogoutClick={this.onLogoutClick.bind(this)}
          token={this.props.Auth.token}
        />
      </Row>,
      <Row key={1} className={css(style.navbar.wrapper)}>
        <Navbar token={this.props.Auth.token} />
      </Row>
    ]
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/partials/Header/index.js